import { Dayjs } from "dayjs";

export enum BookingFilterFormField {
  Date = "date",
  FullUserName = "full_user_name",
  PhoneNumber = "phone_number",
  Auth = "auth",
  tranId = "ottu_tran_Id",
  Field = "field",
  Bookings = "bookings",
  Source = "source",
  Sport = "sport_id",
}

export type BookingFilterFormValues = {
  [BookingFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [BookingFilterFormField.FullUserName]: string | undefined;
  [BookingFilterFormField.PhoneNumber]: string | undefined;
  [BookingFilterFormField.Sport]: string | undefined;
  [BookingFilterFormField.Auth]: string | undefined;
  [BookingFilterFormField.tranId]: string | undefined;
  [BookingFilterFormField.Field]: string | undefined;
  [BookingFilterFormField.Bookings]: boolean | undefined;
  [BookingFilterFormField.Source]: string | undefined;
};
